export interface StopDelay {
    initialDelay: number;
    delay: number;
}

export interface PrizeCountStopTimingMap {
    [count: number]: StopDelay;
}

export class FirecatcherConstants {
    public static readonly RESPINS_AMOUNT: number = 3;
    public static readonly LAST_RESPIN_ADDITIONAL_TIME: number = 500;
    public static readonly LAST_TRY_ADDITIONAL_TIME: number = 500;

    public static PRIZE_COUNT_STOP_TIMING_MAP: PrizeCountStopTimingMap = {
        6: {
            initialDelay: 1500,
            delay: 250
        },
        7: {
            initialDelay: 1500,
            delay: 300
        },
        8: {
            initialDelay: 1500,
            delay: 350
        },
        9: {
            initialDelay: 1600,
            delay: 400
        },
        10: {
            initialDelay: 1700,
            delay: 500
        },
        11: {
            initialDelay: 1800,
            delay: 650
        },
        12: {
            initialDelay: 1900,
            delay: 1000
        },
        13: {
            initialDelay: 2000,
            delay: 2000
        },
        14: {
            initialDelay: 4000,
            delay: 4000
        }
    };
}